import { UIActionType, UIAction } from '../../actions/uiActions';

const currentWorkspaceReducer = (state = '', action: UIAction) => {
  if (action.type === UIActionType.SET_CURRENT_WORKSPACE_ID) return action.id;
  return state;
};

export default currentWorkspaceReducer;
